import { get, isArray } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';

// import schemas
import { Box, Typography } from '@mui/material';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { METHOD_GET } from 'src/lib/constants/apis';
import { FOERDERPROGRAMM_ALLGEMINE_HINWEISE_VN_PATHS, FOERDERPROGRAMM_DATEIEN_JE_VN_PATHS } from 'src/lib/constants/componentsPath';
import DownloadsVN from './content/DownloadsVN';
import { STRAPI_URL } from 'src/lib/constants/url';
import FoerderProgrammSchema from 'src/lib/paths/foerderprogramm_FULL_Paths.json';
import Schema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = Schema.attributes;
const FP_P = FoerderProgrammSchema.attributes;

export const VNTreeStructureWichtigeHinweis = (application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Wichtige Hinweise',
			content: <ApplicationHeading title={'Wichtige Hinweise zu Mittelabruf & Verwendungsnachweis'} description={PLATZHALTER_TEXT} />,
			children: GetWichtigeHinweiseVNChildren(application),
		},
	];

	return treeNodes;
};

const GetWichtigeHinweiseVNChildren = (application: any) => {
	const foerderProgram = get(application, VN_P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});

	const hinweisBlock = get(foerderProgram, FP_P.Allgemeine_Hinweise_Zum_Verwendungsnachweis.path, []);

	const hinweisNodes: TreeNodeType[] = hinweisBlock.map((eachHinweis: any) => {
		return {
			label: get(eachHinweis, FOERDERPROGRAMM_ALLGEMINE_HINWEISE_VN_PATHS.Titel, ''),
			content: (
				<>
					<Box sx={{ mt: '1rem' }}>
						<Typography variant='h3' component={'h3'}>
							{get(eachHinweis, FOERDERPROGRAMM_ALLGEMINE_HINWEISE_VN_PATHS.Untertitel, '')}
						</Typography>
						<MarkdownRenderer markdown={get(eachHinweis, FOERDERPROGRAMM_ALLGEMINE_HINWEISE_VN_PATHS.Inhalte, '')} />

						<RenderImage bildPath={get(eachHinweis, FOERDERPROGRAMM_ALLGEMINE_HINWEISE_VN_PATHS.Bild)} />
					</Box>
				</>
			),
		};
	});

	const programmSpezifischDateien = get(foerderProgram, FOERDERPROGRAMM_DATEIEN_JE_VN_PATHS.DateienBlock, []);
	const hasDateien = isArray(programmSpezifischDateien) && programmSpezifischDateien.some((item: any) => item?.Datei);

	const dateienNodes: TreeNodeType = {
		label: 'Downloads',
		content: <DownloadsVN />,
	};

	const nodes: TreeNodeType[] = [...hinweisNodes];
	if (hasDateien) {
		nodes.push(dateienNodes);
	}

	return nodes;
};

const RenderImage: FC<{ bildPath: string }> = ({ bildPath }) => {
	const bildUrl = get(bildPath, 'attributes.url', '');
	const [downloadedImageUrl, setDownloadedImageUrl] = useState<string | null>(null); // State to hold the image URL

	useEffect(() => {
		const fetchImage = async () => {
			try {
				const fileUrl = bildUrl.startsWith('/private/') ? `${STRAPI_URL}/api/files${bildUrl}` : `${STRAPI_URL}${bildUrl}`;
				const response = await fetch(fileUrl, {
					method: METHOD_GET,
					credentials: 'include',
				});

				if (!response.ok) {
					throw new Error('Failed to fetch the image');
				}

				const blob = await response.blob(); // Convert the response to a blob
				const imageObjectUrl = URL.createObjectURL(blob); // Create an object URL
				setDownloadedImageUrl(imageObjectUrl); // Set the URL to the state
			} catch (error) {
				console.error('Error fetching the image:', error);
			}
		};

		if (bildUrl) fetchImage(); // Fetch the image when the component mounts

		// Clean up the object URL to avoid memory leaks
		return () => {
			if (bildUrl) {
				URL.revokeObjectURL(bildUrl);
			}
		};
	}, [bildUrl]);

	if (bildUrl && downloadedImageUrl) {
		return <img src={downloadedImageUrl} alt='Allgemein Hinweis' width={800} />;
	}
	return <></>;
};
